import script from "./FuelGaugeMovil.vue?vue&type=script&setup=true&lang=js"
export * from "./FuelGaugeMovil.vue?vue&type=script&setup=true&lang=js"

import "./FuelGaugeMovil.vue?vue&type=style&index=0&id=0692dd96&lang=css"

const __exports__ = script;

export default __exports__